export default "__VITE_ASSET__ud6jHfYK__"